import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, TextField, DialogActions, FormControlLabel, Checkbox, CircularProgress } from '@mui/material';
import { createMCQPastPaper, createQuickMcqPastPaper, updateMCQPastPaper } from '../../services/subjects/pastPapers';
import { use } from 'react';

function AddPastPaperQuick({ open, onClose, subjectId, loadPastpapers, editPaper = false }) {

    const [paperName, setPaperName] = useState('');
    const [searchString, setSearchString] = useState('');
    //loading state
    const [loading, setLoading] = useState(false);
    const [divider, setDivider] = useState('-');
    // const [description, setDescription] = useState('');
    // const [year, setYear] = useState('');
    // const [order, setOrder] = useState('');
    // const [isActive, setIsActive] = useState(false);
    // const [isFree, setIsFree] = useState(false);
    // const [editMode, setEditMode] = useState(false);
    
        // useEffect(() => {
        //     console.log(editPaper)
        //     if (editPaper) {
        //         setEditMode(true);
        //         setPaperName(editPaper.questionPaper.paperName || '');
        //         setDescription(editPaper.questionPaper.paperDescription || '');
        //         setYear(editPaper.year || '');
        //         setOrder(editPaper.questionPaper.sortingOrder || '');
        //         setIsActive(editPaper.questionPaper.isActive || false);
        //         setIsFree(editPaper.questionPaper.isFreeToAccess || false);
        //     } else {
                 
        //         setEditMode(false);
        //         setPaperName('');
        //         setDescription('');
        //         setYear('');
        //         setOrder('');
        //         setIsActive(false);
        //         setIsFree(false);
        //     }
        // }, [editPaper]);
    
        const handleAddPaper = async () => {
            if(!paperName || !searchString || divider===""){
                alert("Please fill in all required fields.");
                return;
            }
            if(loading){
                return;
            }
            
            const pastPaper = {
                searchString,
                paperName,
                subjectId,
                divider,
            };

            try{
                setLoading(true);
                await createQuickMcqPastPaper(pastPaper);
            }catch(error){
                console.log(error);
                alert("Error creating past paper." + error.message);
            }finally{
                setLoading(false);
            }
            setPaperName('');
            // setDescription('');
            // setYear('');
            // setOrder('');
            // setIsActive(false);
            // setIsFree(false);
             
            loadPastpapers();
            onClose();
        };

  return (
    <Dialog open={open} onClose={onClose}>
            <DialogTitle style={{ fontSize: '1.5rem' }}>
                {'Add Past Paper'}
            </DialogTitle>
            <DialogContent>
                {loading ? <CircularProgress /> : null}
                <TextField
                    margin="normal"
                    label="Search String"
                    fullWidth
                    value={searchString}
                    onChange={(e) => setSearchString(e.target.value)}
                />

                <TextField
                    margin="normal"
                    label="Paper Name"
                    fullWidth
                    value={paperName}
                    onChange={(e) => setPaperName(e.target.value)}
                />
                <TextField
                    margin="normal"
                    label="Divider"
                    fullWidth
                    value={divider}
                    onChange={(e) => setDivider(e.target.value)}
                />
                {/* <TextField
                    margin="normal"
                    label="Year"
                    fullWidth
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                /> */}
                {/* <TextField
                    margin="normal"
                    label="Order"
                    fullWidth
                    value={order}
                    onChange={(e) => setOrder(e.target.value)}
                /> */}
                {/* <FormControlLabel
                    control={<Checkbox checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />}
                    label="Active"
                />
                <FormControlLabel
                    control={<Checkbox checked={isFree} onChange={(e) => setIsFree(e.target.checked)} />}
                    label="Free to Access"
                /> */}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleAddPaper} variant="contained" color="primary" disabled={loading}>
                    { 'Add'}
                </Button>
            </DialogActions>
        </Dialog>
  )
}

export default AddPastPaperQuick